import { getDB } from '@/shared/storage';
import { recomputeComposite } from './rollup';

/**
 * Sweeps any leaf jobs that were 'running' when the app last closed and marks
 * them 'interrupted' so the user can choose to retry. Recomputes any
 * affected composite parents.
 */
export async function recoverInterruptedJobs(): Promise<number> {
  const db = getDB();
  const stuck = await db.jobs.where('status').equals('running').toArray();
  if (stuck.length === 0) return 0;

  const parentIds = new Set<string>();
  for (const job of stuck) {
    await db.jobs.update(job.id, {
      status: 'interrupted',
      error: 'Interrupted before completion.',
      completedAt: Date.now(),
    });
    if (job.parentJobId) parentIds.add(job.parentJobId);
  }
  for (const parentId of parentIds) await recomputeComposite(parentId, db);
  return stuck.length;
}
